import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Select } from '@platform/base';
import CompMeta from '../../meta/LowCodeComponents/Select';
/**
 * @class NCSelect
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCSelect
 * @label 下拉
 *
 */
class NCSelect extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
         * @title 区域编码
         * @description 组件标识
         */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title className
         * @description 样式
         */
        className: PropTypes.string,
        /**
         * @title 自动化Id
         * @description 自动化Id
         */
        fieldid: PropTypes.string,
        /**
         * @title 多选
         * @description 多选个
         */
        multiple: PropTypes.bool,
        /**
        * @title renderInTable
        * @description renderInTable
        */
        renderInTable: PropTypes.bool,
        /**
         * @title 搜索
         * @description 搜索
         */
        supportSearch: PropTypes.bool,
        /**
         * @title 必填标识
         * @description 必填标识
         */
        showStar: PropTypes.bool,
        /**
        * @title 禁用
        * @description 禁用
        */
        disabled: PropTypes.bool,
    }
    static getCompMeta = () => {
        return CompMeta;
    }

    static defaultProps = {
        disabled: false
    }

    render() {
        return (
            <Select {...this.props} />
        )
    }
}

export default NCSelect;
